import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetFormularioPECATAByID = {
  status: number | null;
  statusText: string | null;
};

const useGetFormularioPECATAByID = () => {
  const [loadingGetFormularioPECATAByID, setLoadingFormularioPECATAByID] = useState(false);
  const [successGetFormularioPECATAByID, setSuccessFormularioPECATAByID] = useState(false);
  const [errorGetFormularioPECATAByID, setErrorFormularioPECATAByID] = useState<any>(null);
  const [dataGetFormularioPECATAByID, setDataFormularioPECATA] = useState<any>(null);

  const [statusGetFormularioPECATAByID, setStatusGetFormularioPECATAByID] =
    useState<StatusGetFormularioPECATAByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getFormularioPECATAByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingFormularioPECATAByID(true);
    setSuccessFormularioPECATAByID(false);
    setErrorFormularioPECATAByID(null);

    try {
      const res = await apiRecord.getSolicitudPecataByID(userId, prestacionId, id);

      setStatusGetFormularioPECATAByID({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessFormularioPECATAByID(true);
      setDataFormularioPECATA(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetFormularioPECATAByID({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorFormularioPECATAByID(err);
      console.error("Error en getFormularioPECATAByID:", err);

      throw err;

    } finally {
      setLoadingFormularioPECATAByID(false);
    }
  };

  return {
    getFormularioPECATAByID,
    loadingGetFormularioPECATAByID,
    successGetFormularioPECATAByID,
    errorGetFormularioPECATAByID,
    dataGetFormularioPECATAByID,
    statusGetFormularioPECATAByID
  };
};

export default useGetFormularioPECATAByID;
